module.exports = __webpack_public_path__ + "img/digitalNomad.0834b362.svg";